import { getItem, setItem } from "@/utils/storage";

const TOKEN_KEY = "@token";

export const storeApiToken = async (token: string) => {
  await setItem(TOKEN_KEY, token);
};

export const retrieveApiToken = async () => {
  const token = await getItem(TOKEN_KEY);
  if (!token) return;
  return `Bearer ${token}`;
};
